import React, { useState, useEffect } from 'react';
import { signInWithEmailAndPassword } from "firebase/auth";
import {
    Stack,
    TextField,
    Box,
    Divider,
    Button,
    Avatar
} from '@mui/material';
import { auth } from '../../firebase/firebase';
import Logo from '../../assets/Cambrya_Logo.png'

const Auth = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleLogin = async () => {
        //e.preventDefault();
        setError("");
        setLoading(true);

        try {
            await signInWithEmailAndPassword(auth, email, password);
            // AuthContext will update user automatically
        } catch (err) {
            setError("Invalid email or password");
        }

        setLoading(false);
    };

    if (loading) return <div>Loading...</div>;

    return (
        <Box p="0 25rem 15rem 25rem" textAlign="center">
            <img src={Logo} style={{width: '240px'}}/>
            {/* <Avatar
                alt="Cambrya"
                src={Logo}
                sx={{ width: "15rem", height: "15rem", padding: "5rem", margin: "auto" }}
            /> */}
            <Box sx={{ m: 2 }}>
                <Stack direction="column" spacing={2}>
                    <input
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <TextField
                        id="password"
                        label="Password"
                        variant="outlined"
                    />
                </Stack>
            </Box>
            <Divider />
            <Box sx={{ m: 2 }}>
                <Stack direction="row" spacing={1} justifyContent="flex-end">
                    <Button variant="outlined" onClick={() => handleLogin()}>Sign In</Button>
                </Stack>
            </Box>
        </Box>
    )
};

export { Auth };